export const SIZE_PRESETS = {
  tufted: { label: "Hand-Tufted Rugs", sizes: ["2×3", "2×6", "2.6×7", "2.6×8", "3×5", "4×6", "5×7", "5×8", "8×10", "9×12"] },
  jute: { label: "Jute Rugs", sizes: ["3×3", "4×4", "3×5", "4×6"] },
};

const cell = "w-full border border-[#D8D4CC] bg-white px-2 py-1.5 text-[13px] outline-none focus:border-[#1B3B36] disabled:bg-[#EFECE5] disabled:text-[#84968C]";

export const sortVariants = (variants, preset) => {
  const order = SIZE_PRESETS[preset]?.sizes || [];
  const idx = (s) => (order.indexOf(s) === -1 ? 999 : order.indexOf(s));
  return [...variants].sort((a, b) => idx(a.size) - idx(b.size));
};

export default function SizeVariantsEditor({ variants, preset, onPresetChange, onChange, defaultPrice, defaultMrp }) {
  const sizes = [...SIZE_PRESETS[preset].sizes, ...variants.map((v) => v.size).filter((s) => !SIZE_PRESETS[preset].sizes.includes(s))];
  const find = (size) => variants.find((v) => v.size === size);

  const toggle = (size) => {
    const v = find(size);
    if (v) onChange(variants.map((x) => (x.size === size ? { ...x, enabled: !x.enabled } : x)));
    else onChange([...variants, { size, enabled: true, price: defaultPrice || 0, mrp: defaultMrp || "", stock: 10 }]);
  };
  const update = (size, k, val) => onChange(variants.map((x) => (x.size === size ? { ...x, [k]: val } : x)));

  return (
    <div className="lg:col-span-2 border-t border-[#EAE7DF] pt-6 mt-2" data-testid="pf-variants-section">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <div className="overline">Size variants (in feet)</div>
        <select value={preset} onChange={(e) => onPresetChange(e.target.value)} data-testid="pf-variants-preset" className="border border-[#D8D4CC] bg-white px-3 py-2 text-[13px]">
          {Object.entries(SIZE_PRESETS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>
      <p className="text-[12px] text-[#84968C] font-light mb-4">
        Tick the sizes this product is sold in and set a price, MRP and stock for each one. Customers only see ticked sizes. The first ticked size is selected by default. Leave every size unticked to keep the single price above.
      </p>
      <div className="grid grid-cols-[90px_1fr_1fr_1fr] gap-x-3 gap-y-2 items-center text-[12px]">
        <div className="text-[#84968C] uppercase tracking-[0.15em]">Size</div>
        <div className="text-[#84968C] uppercase tracking-[0.15em]">Price (₹)</div>
        <div className="text-[#84968C] uppercase tracking-[0.15em]">MRP (₹)</div>
        <div className="text-[#84968C] uppercase tracking-[0.15em]">Stock</div>
        {sizes.map((size) => {
          const v = find(size);
          const on = !!v?.enabled;
          const id = size.replace(/[^0-9a-z]/gi, "-");
          return [
            <label key={`${size}-l`} className="flex items-center gap-2 text-[13px] text-[#1B3B36] cursor-pointer">
              <input type="checkbox" checked={on} onChange={() => toggle(size)} data-testid={`pf-variant-toggle-${id}`} /> {size}
            </label>,
            <input key={`${size}-p`} type="number" disabled={!on} value={v?.price ?? ""} onChange={(e) => update(size, "price", e.target.value)} data-testid={`pf-variant-price-${id}`} className={cell} />,
            <input key={`${size}-m`} type="number" disabled={!on} value={v?.mrp ?? ""} onChange={(e) => update(size, "mrp", e.target.value)} data-testid={`pf-variant-mrp-${id}`} className={cell} />,
            <input key={`${size}-s`} type="number" disabled={!on} value={v?.stock ?? ""} onChange={(e) => update(size, "stock", e.target.value)} data-testid={`pf-variant-stock-${id}`} className={cell} />,
          ];
        })}
      </div>
    </div>
  );
}
